module.exports = __webpack_public_path__ + "static/media/foto_gps.31ac756b.jpg";